import App from "./src/component/App";

const $app = document.getElementById('App') as HTMLElement;
new App($app, {});